import { Link, useNavigate } from '@tanstack/react-router'
import { useAuth } from '~/lib/auth'

export function AppHeader() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  async function handleLogout() {
    await logout()
    navigate({ to: '/login' })
  }

  return (
    <nav
      className="sticky top-0 z-50 border-b border-[var(--line)] bg-[rgba(17,19,34,0.82)] backdrop-blur-[14px]"
      aria-label="Account navigation"
    >
      <div className="mx-auto flex h-16 max-w-[1320px] items-center justify-between px-[var(--gutter)]">
        <Link
          to="/"
          className="flex items-center gap-[10px] font-mono text-[13px] font-[600] tracking-[0.28em] uppercase text-ink"
          aria-label="Provenance — Home"
        >
          <span className="brand-mark" aria-hidden="true" />
          Provenance
        </Link>

        {user ? (
          <div className="flex items-center gap-3">
            <Link
              to="/dpp"
              className="hidden font-mono text-[11px] font-[500] tracking-[0.14em] uppercase text-ink-soft transition-colors hover:text-ink sm:inline-flex"
              activeProps={{ className: 'text-ink' }}
            >
              My Passports
            </Link>
            <Link
              to="/account"
              className="font-mono text-[11px] font-[500] tracking-[0.12em] uppercase border border-[var(--line-strong)] px-[14px] py-[10px] text-ink transition-colors hover:border-ink-soft"
              activeProps={{ className: 'border-accent' }}
            >
              Account
            </Link>
            <button
              type="button"
              onClick={handleLogout}
              className="hidden font-mono text-[11px] font-[500] tracking-[0.12em] uppercase text-ink-mute transition-colors hover:text-ink sm:inline-flex"
            >
              Sign out
            </button>
          </div>
        ) : (
          <div className="flex items-center gap-3">
            <Link
              to="/login"
              className="font-mono text-[11px] font-[500] tracking-[0.12em] uppercase border border-[var(--line-strong)] px-[14px] py-[10px] text-ink transition-colors hover:border-ink-soft"
            >
              Sign in
            </Link>
            <Link
              to="/register"
              className="inline-flex items-center gap-[10px] bg-accent border border-accent px-[14px] py-[10px] font-mono text-[11px] font-[600] tracking-[0.12em] uppercase text-accent-ink transition-colors hover:bg-accent-dark hover:border-accent-dark"
            >
              Create account
            </Link>
          </div>
        )}
      </div>
    </nav>
  )
}
